export default __webpack_public_path__ + "static/media/akhi.73a6aa00.png";